var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssProps),attrs:{"id":"app"}},[(_vm.notfound)?_c('NotFound'):_c('router-view',{on:{"onerror":_vm.onerror}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }